import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SiteFooterComponent } from './shared/site-footer.component';
import { SiteHeaderComponent } from './shared/site-header.component';
import { CartStore } from './core/cart.store';
import { FlowerClickEffectComponent } from './shared/flower-click-effect.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SiteHeaderComponent, SiteFooterComponent, FlowerClickEffectComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly cart = inject(CartStore);
  constructor() { this.cart.load(); }
}
